import { ButtonTypes } from '@deliveryhero/pd-cookbook/components/ButtonV2';
import React from 'react';

export enum ActionType {
  RightDrawer = 'right',
  FullDialog = 'fullDialog',
  AppDialog = 'appDialog'
}

export interface ActionCommonProps {
  component: React.ReactNode;
}

type ActionTypeProps =
  | {
      type: ActionType.RightDrawer;
      options?: {
        title: string;
      };
    }
  | {
      type: ActionType.FullDialog;
      options?: {
        title?: string;
        action?: {
          label: string;
          callback: () => unknown;
          disabled?: boolean;
          loading?: boolean;
          type?: ButtonTypes;
        };
      };
    }
  | {
      type: ActionType.AppDialog;
      options?: {
        title: string | JSX.Element;
        content: string | JSX.Element;
      };
    };

export type ActionProps = ActionCommonProps & ActionTypeProps;

export interface Props {
  children: React.ReactNode | React.ReactNode[];
  actions?: Record<string, ActionProps>;
  pageOptions?: {
    fullDialogWidth?: number;
  };
}
